import { inject } from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP } from '@brighthub/admin-contract';
import { PluginRegistryService } from '@brighthub/plugin';
import { MenuKey, MenuStore } from '@brighthub/shell/data-access-menu';

/**
 * Shared Administration nav metadata. Registered under both {@link MenuKey.MAIN}
 * (sidebar) and {@link MenuKey.SETTINGS} (gear TieredMenu) with the same Okta gate.
 */
const ADMINISTRATION_MENU = {
  label: 'Administration',
  icon: 'pi-wrench',
  route: '/brightnav/admin',
  order: 4,
  groups: [BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP],
} as const;

/**
 * Registers BrightNav administration navigation and any future admin-only initializers
 * for this subapp. Loaded via `BrightnavAdminModule` from the root application config.
 *
 * @remarks The Administration menu entry uses {@link BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP} so only
 * developers in that Okta group see the link; it must match the guard on `/brightnav/admin` in
 * `brightnav.routes.ts`.
 */
export function provideBrightnavAdminPlugin() {
  return [
    provideAppInitializer(() => {
      const registry = inject(PluginRegistryService);
      registry.registerPlugin(() => {
        const menuStore = inject(MenuStore);
        menuStore.register({
          ...ADMINISTRATION_MENU,
          id: 'brightnavAdministration',
          menuKey: MenuKey.MAIN,
          order: 6,
          groups: [...ADMINISTRATION_MENU.groups],
        });
        menuStore.register({
          ...ADMINISTRATION_MENU,
          id: 'brightnavAdministrationSettings',
          menuKey: MenuKey.SETTINGS,
          groups: [...ADMINISTRATION_MENU.groups],
        });
      });
    }),
  ];
}
